<template>
  <common-panel
    id="new-announce-list"
    title="所有公告"
    :needAside="true"
  >
    <span slot="aside" class="asideinfo">{{'（共' + total + '条）'}}</span>
    <div v-for="(v,index) in list" :key="index" class="list-item" @click="itemClick(v.afficheId)">
      <div class="item-left">
        <span class="circle"></span>
        <span class="title">{{v.afficheTitle}}</span>
      </div>
      <span class="date">{{setMoment(v.createTime)}}</span>
    </div>
    <div class="pagination">
      <a-pagination v-model="current" :total="total"  :pageSize="20" @change="change"/>
    </div>

  </common-panel>
</template>

<script>
import CommonPanel from "@/components/common-panel/index"
import moment from 'moment'
import { Pagination } from 'ant-design-vue'
export default {
  components: {
    CommonPanel,
    [Pagination.name]: Pagination
  },
  data() {
    return {
      list:[],
      total: 0,
      current: 1
    }
  },
  created() {
    this.getAfficheList(1, 20)
  },
  methods:{
    setMoment(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    async getAfficheList(page,limit){
      const jsonRes = await this.$store.dispatch('getAfficheList',{page,limit})
      this.list = (jsonRes && jsonRes.data && Array.isArray(jsonRes.data)) ? jsonRes.data : []
      this.total = (jsonRes && jsonRes.count) ? jsonRes.count : 0
    },
    change (page, pageSize) {
      this.getAfficheList(page, pageSize)
    },
    itemClick (id) {
      this.$emit('setMainContent', {component: 'AnnounceDetails', afficheId:id})
    }
  }
}
</script>

<style lang="scss" scoped>
.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 5px 15px 0px;
  border-bottom: 1px solid #f6f6f6;
  .item-left {
    display: flex;
    align-items: center;
    width: 90%;
    .circle {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #ddd;
      flex-shrink: 0;
      margin-right: 10px;
    }
    .title {
      font-size: 15px;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      cursor: pointer;
    }
  }
  .date {
    color: #999;
  }
}
.list-item:first-child {
  padding-top: 0px !important;
}
.pagination {
  margin-top: 50px;
  text-align: right;
}
.asideinfo {
  color: #1C7AE5;
}
</style>
